import { render, staticRenderFns } from "./ModelThreeDetail.vue?vue&type=template&id=59a0e4a8&scoped=true"
import script from "./ModelThreeDetail.vue?vue&type=script&lang=js"
export * from "./ModelThreeDetail.vue?vue&type=script&lang=js"
import style0 from "./ModelThreeDetail.vue?vue&type=style&index=0&id=59a0e4a8&prod&scoped=true&lang=css"
import style1 from "./ModelThreeDetail.vue?vue&type=style&index=1&id=59a0e4a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a0e4a8",
  null
  
)

export default component.exports